"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importDefault(require("../../../styled"));
var tokens_1 = require("../../../tokens");
var Divider = function (props) { return React.createElement(Divider.Element, __assign({}, props)); };
Divider.Element = styled_1.default.legend(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 14px;\n  letter-spacing: 0.5px;\n  font-weight: ", ";\n  border-bottom: 1px solid ", ";\n  padding-bottom: ", ";\n  margin-bottom: ", ";\n  margin-top: 0;\n  width: 100%;\n  color: ", ";\n"], ["\n  font-size: 14px;\n  letter-spacing: 0.5px;\n  font-weight: ", ";\n  border-bottom: 1px solid ", ";\n  padding-bottom: ", ";\n  margin-bottom: ", ";\n  margin-top: 0;\n  width: 100%;\n  color: ", ";\n"])), tokens_1.fonts.weight.medium, tokens_1.colors.form.divider, tokens_1.spacing.xsmall, tokens_1.spacing.large, tokens_1.colors.text.default);
exports.default = Divider;
var templateObject_1;
//# sourceMappingURL=divider.js.map